var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"read-more"},[_vm._v(" "+_vm._s(_vm.expanded ? _vm.value : _vm.short)+" "),(!_vm.expanded && _vm.isAboveLimit)?_c('button',{staticClass:"read-more__expand",attrs:{"type":"button"},on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._v(" "+_vm._s(_vm.$t('readMore'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }